export const UploadDocumentMainGroups = [
    {
        groupCode: '10000',
        groupName: 'Документы, по которым взыскание задолженности производится в бесспорном порядке',
        subgroups: ['10100', '10200', '10300', '10400', '10500'],
    },
    {
        groupCode: '11000',
        groupName: 'Документы, приложение которых обязательно согласно части первой статьи 91.1 Основ',
        subgroups: ['11100', '11200'],
    },
    {
        groupCode: '12000',
        groupName: 'Иные документы',
        subgroups: ['12100', '12200', '12300', '12400', '12500'],
    },
]
export const UploadDocumentTypes = [
    {
        groupCode: "10100",
        groupName: "Нотариально удостоверенные сделки, устанавливающие денежные обязательства или обязательства по передаче имущества",
        documents: [
            {
                value: "10101",
                name: "нотариально удостоверенный договор займа"
            },
            {
                value: "10199",
                name: "иная сделка, удостоверенная нотариально"
            }
        ]
    },
    {
        groupCode: "10200",
        groupName: "Кредитные договоры",
        documents: [
            {
                value: "10201",
                name: "общие условия к кредитному договору"
            },
            {
                value: "10202",
                name: "индивидуальные условия к кредитному договору"
            },
            {
                value: "10203",
                name: "дополнительное соглашение к кредитному договору"
            },
            {
                value: "10204",
                name: "соглашение об уступке прав (переводе долга) по кредитному договору"
            },
            {
                value: "10299",
                name: "иной документ, выражающий содержание кредитного договора"
            }
        ]
    },
    {
        groupCode: "10300",
        groupName: "Договоры, кредитором по которым выступает единый институт развития в жилищной сфере",
        documents: [
            {
                value: "10301",
                name: "договор займа, кредитором по которым выступает единый институт развития в жилищной сфере"
            },
            {
                value: "10302",
                name: "кредитный договор, кредитором по которым на основании уступки прав (требований) выступает единый институт развития в жилищной сфере"
            },
            {
                value: "10303",
                name: "соглашение об уступке прав (переводе долга) по кредитному договору, кредитором по которым на основании уступки прав (требований) выступает единый институт развития в жилищной сфере"
            }
        ]
    },
    {
        groupCode: "10400",
        groupName: "Договоры поручительства, предусматривающие солидарную ответственность поручителя по кредитному договору",
        documents: [
            {
                value: "10401",
                name: "договор поручительства"
            },
            {
                value: "10402",
                name: "дополнительное соглашение к договору поручительства"
            },
            {
                value: "10499",
                name: "иной документ, выражающий содержание договора поручительства"
            }
        ]
    },
    {
        groupCode: "10500",
        groupName: "Договоры об оказании услуг связи",
        documents: [
            {
                value: "10501",
                name: "договор об оказании услуг связи"
            },
            {
                value: "10502",
                name: "правила оказания услуг связи"
            },
            {
                value: "10599",
                name: "иные документы, выражающие содержание договора об оказании услуг связи"
            }
        ]
    },
    {
        groupCode: "10600",
        groupName: "Иные документы, перечень которых устанавливается Правительством Российской Федерации",
        documents: [
            {
                value: "10601",
                name: "залоговый билет (договор займа)"
            },
            {
                value: "10602",
                name: "договор хранения"
            },
            {
                value: "10603",
                name: "именная сохранная квитанция"
            },
            {
                value: "10604",
                name: "договор проката"
            },
            {
                value: "10605",
                name: "документ, подтверждающий передачу арендодателем имущества арендатору"
            },
            {
                value: "10699",
                name: "иной документ, установленный Правительством Российской Федерации"
            }
        ]
    },
    {
        groupCode: "11100",
        groupName: "Расчет задолженности по денежным обязательствам, подписанный взыскателем, с указанием платежных реквизитов счета взыскателя",
        documents: [
            {
                value: "11101",
                name: "расчет задолженности"
            }
        ]
    },
    {
        groupCode: "11200",
        groupName: "Документы об уведомлении должника о наличии задолженности",
        documents: [
            {
                value: "11201",
                name: "копия уведомления о наличии задолженности, направленного взыскателем должнику, содержащее подтверждение направления такого уведомления (почтовый идентификатор)"
            },
            {
                value: "11202",
                name: "копия уведомления о наличии задолженности, направленного взыскателем должнику"
            },
            {
                value: "11203",
                name: "документ, подтверждающий направление уведомления о наличии задолженности"
            },
            {
                value: "11299",
                name: "иные документы, связанные с уведомлением должника о наличии задолженности"
            }
        ]
    },
    {
        groupCode: "12100",
        groupName: "Документы, подтверждающие заключение договора",
        documents: [
            {
                value: "12101",
                name: "заявление о предоставлении кредита (займа)"
            },
            {
                value: "12102",
                name: "выписка по банковскому счету"
            },
            {
                value: "12103",
                name: "документ о заключении договора в электронном виде с применением простой электронной подписи"
            },
            {
                value: "12104",
                name: "уведомление должника о переходе прав кредитора к другому лицу"
            },
            {
                value: "12199",
                name: "иные документы, подтверждающие заключение договора"
            }
        ]
    },
    {
        groupCode: "12200",
        groupName: "Документы, подтверждающие сведения о должнике",
        documents: [
            {
                value: "12201",
                name: "копия паспорта или иного документа, удостоверяющего личность"
            },
            {
                value: "12202",
                name: "документ, подтверждающий адрес должника"
            },
            {
                value: "12203",
                name: "анкета клиента"
            },
            {
                value: "12204",
                name: "свидетельство о заключении брака"
            },
            {
                value: "12205",
                name: "свидетельство о расторжении брака"
            },
            {
                value: "12206",
                name: "свидетельство о перемене имени"
            },
            {
                value: "12299",
                name: "иные документы, подтверждающие сведения о должнике"
            }
        ]
    },
    {
        groupCode: "12300",
        groupName: "Документы, подтверждающие сведения о взыскателе",
        documents: [
            {
                value: "12301",
                name: "опросник о выгодоприобретателях и бенифициарных владельцах"
            },
            {
                value: "12302",
                name: "документ, подтверждающий полномочия (машиночитаемая доверенность)"
            },
            {
                value: "12303",
                name: "лицензия об осуществлении банковских операций"
            },
            {
                value: "12304",
                name: "устав или иной учредительный документ, изменения в устав или иной учредительный документ"
            },
            {
                value: "12305",
                name: "выписка из ЕГРЮЛ"
            },
            {
                value: "12306",
                name: "лист записи ЕГРЮЛ"
            },
            {
                value: "12399",
                name: "иные документы, подтверждающие сведения о взыскателе"
            }
        ]
    },
    {
        groupCode: "12400",
        groupName: "Документы, подтверждающие оплату за совершение нотариального действия",
        documents: [
            {
                value: "12401",
                name: "Платежное поручение или иной документ об оплате нотариального тарифа"
            }
        ]
    },
    {
        groupCode: "12500",
        groupName: "Дополнительные документы информационного характера",
        documents: [
            {
                value: "12501",
                name: "Пояснения взыскателя нотариусу"
            },
            {
                value: "12599",
                name: "Иные документы"
            }
        ]
    }
]
